import { DocumentNode } from '@apollo/client'

import { ARTIFACT_LABEL } from '../../constants'
import { DocPopoverDoctrine } from './components/doc-popover-doctrine'
import { DocPopoverJurisprudence } from './components/doc-popover-jurisprudence'
import { DocPopoverProfile } from './components/doc-popover-profile'
import { DocPopoverSummary } from './components/doc-popover-summary'
import { DocPopoverTermTracker } from './components/doc-popover-term-tracker'
import { DocPopoverTopic } from './components/doc-popover-topic'

export enum EntityEnum {
  TOPIC = 'TOPIC',
  DOCUMENT_TOPIC = 'DOCUMENT_TOPIC',
  SUMMARY = 'SUMMARY',
  JURISPRUDENCE = 'JURISPRUDENCE',
  DOCTRINE = 'DOCTRINE',
  PROFILE_QUICKVIEW = 'PROFILE_QUICKVIEW',
  TRACKER = 'TRACKER',
}

export type EntityType = keyof typeof EntityEnum

export const ENTITY_CONFIG_MAP: Record<EntityType, RenderTypeMap> = {
  TOPIC: {
    Component: DocPopoverTopic,
    selectors: ['.cite', '.topic-popover-trigger'],
    mapIdToVariables: (id) => {
      const tidList = id.split(',').map(toNumber)
      return tidList.length > 0 ? { tidList } : null
    },
  },
  DOCUMENT_TOPIC: {
    Component: DocPopoverTopic,
    selectors: ['.document-topic-popover-trigger'],
    mapIdToVariables: (id) => {
      const tidList = id.split(',').map(toNumber)
      return tidList.length > 0 ? { tidList } : null
    },
  },
  DOCTRINE: {
    Component: DocPopoverDoctrine,
    selectors: ['[data-subject-topic-ref]'],
    mapIdToVariables: (id) => ({
      tid: toNumber(id),
    }),
  },
  SUMMARY: {
    Component: DocPopoverSummary,
    selectors: ['.entity-cite-sumula'],
    mapIdToVariables: (id) => ({
      artifact: ARTIFACT_LABEL.SUMULA,
      docId: toDocId(id),
    }),
  },
  JURISPRUDENCE: {
    Component: DocPopoverJurisprudence,
    selectors: ['.entity-cite', '.process-trigger'],
    mapIdToVariables: (id) => {
      const ids = id
        .split(',')
        .filter((item) => item.startsWith('JURISPRUDENCIA_'))
        .map(toDocId)
      return ids.length > 0
        ? {
            artifact: ARTIFACT_LABEL.JURISPRUDENCIA,
            ids,
          }
        : null
    },
  },
  PROFILE_QUICKVIEW: {
    Component: DocPopoverProfile,
    selectors: ['[data-profile-tooltip]'],
    mapIdToVariables: (id) => ({
      pid: toNumber(id),
    }),
  },
  TRACKER: {
    Component: DocPopoverTermTracker,
    selectors: [],
    mapIdToVariables: (id) => {
      const tidList = id.split(',').map(toNumber)
      return tidList.length > 0 ? { tidList } : null
    },
  },
}

/* helpers */

const onlyNumbers = (str: string) => str.replace(/\D/g, '')
const toDocId = (str: string) => onlyNumbers(str)
const toNumber = (str: string) => parseInt(onlyNumbers(str), 10)

type RenderTypeMap = {
  Component: React.ComponentType<{
    query: any
    entityType: EntityType
    entityUrl: string
    context: string
    hasLRSubscription: boolean
  }> & {
    query: DocumentNode
  }
  mapIdToVariables: (id: string) => Record<string, unknown> | null
  selectors: string[]
}
